<div class="editor-root">
  <div class="range-editor" [formGroup]="rangeForm">
    <div class="range-entries" formArrayName="entries">
      <div class="section-header">
        <h4>Range entries</h4>
        <button mat-stroked-button type="button" (click)="addRangeEntry()">Add range</button>
      </div>

      @for (rangeGroup of rangeEntries.controls; track $index; let rangeIndex = $index) {
        <div class="range-entry" [formGroupName]="rangeIndex">
          <div class="range-top-row">
            <mat-form-field appearance="outline" class="form-field small-field">
              <mat-label>From asset</mat-label>
              <input matInput type="number" formControlName="from" />
            </mat-form-field>
            <mat-form-field appearance="outline" class="form-field small-field">
              <mat-label>To asset</mat-label>
              <input matInput type="number" formControlName="to"
                     placeholder="blank = open" />
            </mat-form-field>
            <mat-form-field appearance="outline" class="form-field small-field">
              <mat-label>Index offset</mat-label>
              <input matInput type="number" formControlName="indexOffset" />
            </mat-form-field>
          </div>

          <div class="filename-format-block">
            <label class="filename-format-label">Filename Format</label>
            <app-token-chip-picker
              [value]="rangeGroup.controls.tokenFormats.value"
              [vocabulary]="tokenVocabulary"
              [showReset]="true"
              (valueChange)="onTokensChange(rangeIndex, $event)"
            ></app-token-chip-picker>
          </div>

          @if (entryPreview(rangeIndex).value !== null) {
            <div class="entry-preview-line">
              <span class="preview-label">Preview:</span>
              <span class="preview-value">{{ entryPreview(rangeIndex).value }}</span>
              @if (entryPreviewSecondary(rangeIndex).value !== null &&
                   entryPreviewSecondary(rangeIndex).value !== entryPreview(rangeIndex).value) {
                <span class="preview-comma">,</span>
                <span class="preview-value">{{ entryPreviewSecondary(rangeIndex).value }}</span>
              }
            </div>
          }

          <div class="entry-footer-row">
            <mat-button-toggle-group formControlName="casing" aria-label="Casing"
                                     class="casing-toggle">
              @for (c of allCasings; track c) {
                <mat-button-toggle [value]="c" [title]="casingTitle(c)">
                  @if (c === 'Match') {
                    <mat-icon class="casing-icon">{{ casingIcon(c) }}</mat-icon>
                    <span class="casing-text">{{ casingLabel(c) }}</span>
                  } @else {
                    <span class="casing-text">{{ casingLabel(c) }}</span>
                    <mat-icon class="casing-icon">{{ casingIcon(c) }}</mat-icon>
                  }
                </mat-button-toggle>
              }
            </mat-button-toggle-group>
            <button mat-stroked-button type="button" (click)="removeRangeEntry(rangeIndex)"
                    class="remove-range-btn">
              Remove range
            </button>
          </div>
        </div>
      }
    </div>
  </div>
</div>
